module.exports = __webpack_public_path__ + "img/Dusk-text.ccdd7d95.jpg";